import script from "./HistoriqueView.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoriqueView.vue?vue&type=script&setup=true&lang=js"

import "./HistoriqueView.vue?vue&type=style&index=0&id=e8160ed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8160ed0"]])

export default __exports__